export const environment = {
  production: false,
  bypassAuthentication: false
};
